<template>
  <div id="app">
    <NavBar />
    <!--ServicePopup :title="titlepop" :message="msgpop" button-label="OK" / -->
    <div>
      <router-view />

      <CookieConsent />

      <GlobalSpinner />
    </div>
    <FooterPage />

  </div>
</template>

<script>

import NavBar from './components/NavBar.vue'
import FooterPage from './components/FooterPage.vue'
// import authService from '@/services/auth.service.js'
import apiService from '@/services/apiService.js'

// import moment from 'moment-timezone'
// import { getCookie } from '@/plugins/tokenManage.js'
// import { getCookie, creaToken, creaTraduzioni } from '@/plugins/cookie.js'
import translationStore from '@/store/translations'
import { reloadTorefres } from '@/plugins/cookie-updater'
import GlobalSpinner from '@/components/GlobalSpinner.vue'
import CookieConsent from '@/components/CookieConsent.vue'
import loadingStore from '@/store/loading'
// import ServicePopup from '@/components/ServicePopup.vue'

export default {
  name: 'app',
  metaInfo: function () {
    return {

      title: this.titlePage,
      titleTemplate: this.titlePage || 'I GOT U - Your Event Guest List reinvented for iPad and Android',
      meta: [
        { charset: 'utf-8' },
        { name: 'keywords', content: this.meta.key || 'events,guest,organizer,app,ios,ipad' },
        { name: 'description', content: this.meta.desciption || 'I GOT U is a guest check-in system for professional event organizers. It is the most easy-to-use app. Your guest lists always synched. On all your devices. Real Time.' }
      ],
      htmlAttrs: {
        lang: this.lang,
        amp: true
      }
    }
  },
  data () {
    return {
      translation: translationStore,
      titlePage: '',
      titlepop: '',
      msgpop: '',
      meta: {
        key: '',
        desciption: '',
        lang: ''
      }
    }
  },
  components: {
    NavBar,
    FooterPage,
    GlobalSpinner,
    CookieConsent
    // ServicePopup
  },

  methods: {
    async getTranslations (token) {
      try {
        if (!translationStore.getters.traduzioniCaricate) {
          const userLangBrowse = navigator.language || navigator.userLanguage
          const userLang = userLangBrowse.replace('-', '_')
          // const lang = 'IT'

          // const languageCode = userLang.substring(0, 2) // Estrae "it"
          const url = process.env.VUE_APP_URL_LANG + '/' + userLang

          // const url = 'https://igotu.it/api/translations/' + userLang

          // const langString = languageCode.toUpperCase() // Converte in "IT"

          // const payload = { uid: process.env.VUE_APP_UID_PROJECT, lang: userLang }

          const json = await apiService.sendRequestWithBearer('GET', url, token, null)

          translationStore.dispatch('caricaTraduzioni', json)
          const chiaveIt = Object.keys(this.translation.getters.avaiable).find(chiave => chiave === userLang)

          if (chiaveIt) {
            this.translation.dispatch('cambiaLingua', userLang)
            await this.translation.dispatch('fissaLingua')
          }
        }
      } catch (error) { }
    }

  },

  async created () {
    if (!loadingStore.isLoading) {
      loadingStore.commit('setLoading', true)
    }

    const token = await apiService.getClientCredentialsToken()

    if (!token) {
      this.$router.push('/error')
    } else {
      await reloadTorefres()
      this.getTranslations(token)
      this.titlePage = this.translation.getters.traduzione('page.title')
      this.meta.key = this.translation.getters.traduzione('page.keywords')
      this.meta.desciption = this.translation.getters.traduzione('page.description')
      this.meta.lang = this.translation.getters.lingua

      this.titlepop = this.translation.getters.traduzione('titolo.avviso.popup')
      this.msgpop = this.translation.getters.traduzione('testo.messaggio.avviso')
    }

    loadingStore.commit('setLoading', false)
  },
  mounted () {
    this.titlePage = this.translation.getters.traduzione('page.title')
    this.meta.key = this.translation.getters.traduzione('page.keywords')
    this.meta.desciption = this.translation.getters.traduzione('page.description')
    this.titlepop = this.translation.getters.traduzione('titolo.avviso.popup')
    this.msgpop = this.translation.getters.traduzione('testo.messaggio.avviso')
    this.meta.lang = this.translation.getters.lingua
    loadingStore.commit('setLoading', false)
  }
}
</script>
